var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.loaded
      ? _c(
          "div",
          { staticClass: "text-center" },
          [_c("loader", { staticClass: "mt-50 mb-50" })],
          1
        )
      : _c("div", { staticClass: "p-20" }, [
          _c(
            "div",
            [
              _vm.loaded
                ? _c("bar-chart", {
                    key: _vm.chartKey,
                    attrs: { chartdata: _vm.chartdata, options: _vm.options }
                  })
                : _vm._e()
            ],
            1
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }